<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize',
        isProductAdvertiserAgencySelected ? 'selected' : ''
      ]"
      @click="form.productAdvertiserAgency.showProductAdvertiserAgencyModal = true"
    >
      Agency / Advertiser / Product
    </button>
    <b-modal
      v-model="form.productAdvertiserAgency.showProductAdvertiserAgencyModal"
      title="Choose Agency / Advertiser / Product"
      :no-close-on-backdrop="true"
      @ok="saveProductAdvertiserAgency"
      @show="showModal"
      @hide="onHidden"
    >
      <div>
        <label>Agency</label>
        <div class="input-group mb-3">
          <v-select
            v-model="selectedBuyingAgency"
            class="vueSelect"
            :options="form.buyingAgencies"
          />
        </div>
  
        <div class="input-group mb-3">
          <label>Advertiser</label>
          <div class="input-group">
            <v-select
              v-model="selectedAdvertiser"
              class="vueSelect"
              :options="form.advertisers"
            />
          </div>
        </div>
        <div class="input-group">
          <label>Product</label>
          <div class="input-group mb-3">
            <v-select
              v-model="selectedProduct"
              class="vueSelect"
              :options="form.products"
            />
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
  <script>
  import "vue-select/dist/vue-select.css";
  import vSelect from "vue-select";
  
  export default {
    name: "ProductAdvertiserAgencyBubble",
    components: {
      vSelect
    },
    props: {
      form: Object,
    },
    data() {
      return {
        selectedBuyingAgency: "",
        selectedAdvertiser: "",
        selectedProduct: ""
      };
    },
    computed: {
      isProductAdvertiserAgencySelected() {
        let isProductAdvertiserAgencySelected = false;
        let query = this.$store.getters['campaignApiBody/getPayload'];
        if (query.advertiser !== -1 || query.buyingAgency !== -1 || query.product !== -1)
          isProductAdvertiserAgencySelected = true;
        return isProductAdvertiserAgencySelected;
      }
    },
    methods: {
      onKeyUp(event) {
        if (
          event.key === "Enter" &&
          this.form.productAdvertiserAgency.showProductAdvertiserAgencyModal
        ) {
          this.saveProductAdvertiserAgency();
          this.form.productAdvertiserAgency.showProductAdvertiserAgencyModal= false;
        }
      },
      onHidden() {
        document.removeEventListener("keyup", this.onKeyUp);
      },
      setProductAdvertiserAgency() {
        let query = this.$store.getters['campaignApiBody/getPayload'];
        this.selectedAdvertiser = query.advertiser !== -1 ? this.form.advertisers.find(a => a.id == query.advertiser) : "";
        this.selectedBuyingAgency = query.buyingAgency !== -1 ? this.form.buyingAgencies.find(b => b.id == query.buyingAgency) : "";
        this.selectedProduct = query.product !== -1 ? this.form.products.find(p => p.id == query.product)  : "";
      },
      saveProductAdvertiserAgency() {
        const advertiserId = this.selectedAdvertiser?.id ?? -1;
        const buyingAgencyId = this.selectedBuyingAgency?.id ?? -1;
        const productId = this.selectedProduct?.id ?? -1;

        const payload = {
          ...this.$store.getters['campaignApiBody/getPayload'],
          advertiser: advertiserId,
          buyingAgency: buyingAgencyId,
          product: productId
        };

        this.$store.commit('campaignApiBody/updatePayload', payload);
      },
      showModal() {
        this.setProductAdvertiserAgency();
        document.addEventListener("keyup", this.onKeyUp);
      }
    }
  };
  </script>
  
  <style scoped>
  .vueSelect {
    width: 100%;
    font-size: 0.875rem;
  }
  </style>
  